<template>
  <router-link
    :to="to"
    class="sidenav-link"
    :class="{ 'sidenav-link--bordered': isBordered }"
  >
    <v-icon
      v-if="iconType"
      :type="iconType"
      class="sidenav-link__icon"
      size="lg"
    />
    {{ text }}
  </router-link>
</template>

<script>
  import Icon from "@/atoms/Icon";

  export default {
    components: {
      "v-icon": Icon
    },
    props: {
      to: {
        type: String,
        default: null
      },
      text: {
        type: String,
        default: null
      },
      isBordered: {
        type: Boolean,
        default: false
      },
      iconType: {
        type: String,
        default: null
      }
    }
  };
</script>

<style lang="scss">
@import "../../styles/shared/shared";

.sidenav-link {
  position: relative;
  display: block;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  overflow: hidden;
  color: rgba($white, 0.65);
  &--bordered {
    padding-left: $page-gutter;
    padding-right: $page-gutter;
    border-top: solid 1px rgba($white, 0.3);
    &:last-of-type {
      border-bottom: solid 1px rgba($white, 0.3);
    }
    &:after {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 4px;
      background-color: $tangerine;
      transform: translateX(-4px);
      transition: 0.15s ease;
      content: "";
    }
  }
  &:hover,
  &:focus {
    text-decoration: none;
    color: rgba($white, 0.65);
  }

  &.router-link-active,
  &--active {
    background-color: rgba($white, 0.1);
    &,
    &:focus,
    &:hover {
      color: $white;
    }
  }

  &:hover,
  &.router-link-active,
  &--active {
    &:after {
      transform: translateX(0);
      box-shadow: 0 0 0 2px rgba($black, 0.2);
    }
  }
  &__icon {
    width: 1.5em;
    margin-right: .25rem;
    text-align: center;
    vertical-align: middle;
    font-size: 1.5rem;
  }
}
</style>
